import { getApiClient } from '@src/services/api-client'
import { useQuery } from '@tanstack/react-query'
import { ReportPayoutThatSkippedIncomeValidationDatas } from '../../types/ReportPayoutWithoutFlinkData'

const REPORT_PAYOUT_THAT_SKIPPED_INCOME_VALIDATION = '/Report/GetPayoutThatSkippedIncomeValidation'

// Query Keys
export const reportKeys = {
  all: ['report'] as const,
  payoutThatSkippedIncomeValidation: () => [...reportKeys.all, 'payoutThatSkippedIncomeValidation'] as const,
}

// API Functions
export async function getPayoutThatSkippedIncomeValidation(): Promise<ReportPayoutThatSkippedIncomeValidationDatas[]> {
  const apiClient = getApiClient()
  const response = await apiClient.get<ReportPayoutThatSkippedIncomeValidationDatas[]>(
    REPORT_PAYOUT_THAT_SKIPPED_INCOME_VALIDATION,
  )
  return response.data
}

// React-Query Hooks
export function usePayoutThatSkippedIncomeValidation(): [ReportPayoutThatSkippedIncomeValidationDatas[], boolean] {
  const { data, isFetching } = useQuery<ReportPayoutThatSkippedIncomeValidationDatas[]>({
    queryKey: reportKeys.payoutThatSkippedIncomeValidation(),
    queryFn: getPayoutThatSkippedIncomeValidation,
  })
  return [data ?? [], isFetching]
}

